import { required, email } from "react-admin";

export const validateEmailAddress = [required(), email()];
